import React, { useEffect } from 'react';

import { useOrderContext } from 'hooks';

import { SqPaymentReceiptsDispute } from '../SqPaymentReceiptsDispute';

export const SqCustomerPaidReceipts: React.FC = () => {
  const {
    onConfirmPayment,
    receiptsResult: { setReceiptUploadCallbacks, isUploadingReceipt },
  } = useOrderContext();

  useEffect(() => {
    setReceiptUploadCallbacks(onConfirmPayment, () => {});
  }, [onConfirmPayment, setReceiptUploadCallbacks]);

  return (
    <div className="tw-px-4 tw-py-16">
      {!isUploadingReceipt && <SqPaymentReceiptsDispute />}
    </div>
  );
};
